import { AuthorityType } from './authority-type.enum';

/**
 * è´¦å·è§è²
 */
export class Authority {
  /**
   * è´¦å·è§è²ç±»å
   */
  authority: AuthorityType;
}
